import React, { FC } from 'react';
import { ChangePasswordSection, ChangePasswordProvider } from 'aw-package-react-authentication';
import { Form, FormSection } from 'omni-package-react-core';
import { useTranslation } from 'react-i18next';
import { getProfileApiRoot } from '../../../utils/getProfileApiRoot';
import PasswordRow from '../../../components/_PasswordRow';
import Constants from '../../../Constants';

export interface ChangePasswordFormProps { }

const ChangePasswordForm: FC<ChangePasswordFormProps> = () => {
  const { t } = useTranslation('ChangePasswordFormPage');
  const buildPayload = (values: unknown) => {
    const inputsMap = new Map(Object.entries(values));
    return (
      {
        newPassword: inputsMap.get('password'),
        password: inputsMap.get('currentPassword'),
      });
  };

  const fields: { [name: string]: string } = {};
  fields.password = 'currentPassword';
  fields.newPassword = 'password';
  return (
    <Form
      name="ChangePasswordForm"
      url={`${getProfileApiRoot()}/password`}
      createMethod="PUT"
      formTitle={t('title')}
      transformRequest={(values: unknown) => buildPayload(values)}
      controlErrorMapping={fields}
      confirmationPath={Constants.ChangePasswordConfirmationPath}
    >
      <FormSection>
        <PasswordRow />
        <ChangePasswordProvider>
          <ChangePasswordSection />
        </ChangePasswordProvider>
      </FormSection>
    </Form>
  );
};

export default ChangePasswordForm;
